import StandardRestError from './Standard'

class TrialEmailDisposableError extends StandardRestError {
  static CODE = 'TRIAL_EMAIL_DISPOSABLE'

  constructor(_serverMessage?: string, status = 422, body = {}) {
    super(
      'Use a permanent email address. Throwaway inboxes cannot start a trial.',
      status,
      body,
    )
  }
}

export default TrialEmailDisposableError
